export function Minus() {
  return <path fill="currentColor" d="M3 27h42c1.657 0 3-1.343 3-3s-1.343-3-3-3H3c-1.657 0-3 1.343-3 3s1.343 3 3 3z" />
}
